const C = {
  name: "Fingerprint",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C8.47 0 5.41 2.04 3.94 5H6.26C7.53 3.19 9.63 2 12 2C15.86 2 19 5.14 19 9V11H21V9C21 4.04 16.96 0 12 0Z" fill="currentColor"/>
<path d="M19 13V15C19 17.79 17.36 20.2 15 21.32V23.48C18.49 22.25 21 18.91 21 15V13H19Z" fill="currentColor"/>
<path d="M5 15V9C5 8.31 5.1 7.63 5.29 7H3.22C3.08 7.64 3 8.31 3 9V15C3 19.96 7.04 24 12 24C12.34 24 12.67 23.98 13 23.94V21.92C12.67 21.98 12.34 22 12 22C8.14 22 5 18.86 5 15Z" fill="currentColor"/>
<path d="M15 11V15C15 16.65 13.65 18 12 18C10.35 18 9 16.65 9 15H7C7 17.76 9.24 20 12 20C14.76 20 17 17.76 17 15V11H15Z" fill="currentColor"/>
<path d="M12 4C9.24 4 7 6.24 7 9V13H9V9C9 7.35 10.35 6 12 6C13.65 6 15 7.35 15 9H17C17 6.24 14.76 4 12 4Z" fill="currentColor"/>
<path d="M13 16V8H11V16H13Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Fingerprint
};
